import $ from 'jquery';

const selectors = {
  cookie: '.js-cookie-bar'
}

export default class Cookie {
  constructor(element){
    // Check if cookie is set on initialize
    this.checkCookie();

    // Bind events
    $(selectors.cookie).on('click', '.accept', this.onClick)
  }

  checkCookie(){
    if (localStorage.getItem('cookiedone')) {
        $(selectors.cookie).remove();
    } else {
        $(selectors.cookie).fadeIn();
    }
  }

  onClick(e){
    localStorage.setItem('cookiedone', 'thanks');
    $('.cookie-bar').fadeOut();
    e.preventDefault();
  }
}

/*
 * Create a new Cookie() instance
 */
new Cookie();
